"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRCodeBlockchain = void 0;
var _react = _interopRequireDefault(require("react"));
var _definitions = require("@ppay/definitions");
var _QRCode = require("./QRCode");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getBlockchainUrl = function getBlockchainUrl(blockchain, address) {
  switch (blockchain) {
    case _definitions.Blockchain.BITCOIN:
      return 'bitcoin:' + address;
    case _definitions.Blockchain.ETHEREUM:
      return 'ethereum:' + address;
    default:
      return address;
  }
};
var QRCodeBlockchain = function QRCodeBlockchain(_ref) {
  var size = _ref.size,
    blockchain = _ref.blockchain,
    address = _ref.address,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement(_QRCode.QRCode, {
    $blurred: !address,
    size: size,
    value: getBlockchainUrl(blockchain, address),
    onClick: onClick
  });
};
exports.QRCodeBlockchain = QRCodeBlockchain;